"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const i = require("@nextcloud/event-bus");
let r;
const o = [];
function a() {
  if (r === void 0) {
    const e = document?.getElementsByTagName("head")[0];
    r = e ? e.getAttribute("data-requesttoken") : null;
  }
  return r;
}
function d(e) {
  o.push(e);
}
i.subscribe("csrf-token-update", (e) => {
  r = e.token, o.forEach((t) => {
    try {
      t(r);
    } catch (s) {
      console.error("error updating CSRF token observer", s);
    }
  });
});
let n;
const u = (e, t) => e ? e.getAttribute(t) : null;
function c() {
  if (n !== void 0)
    return n;
  const e = document?.getElementsByTagName("head")[0];
  if (!e)
    return null;
  const t = u(e, "data-user");
  return t === null ? (n = null, n) : (n = {
    uid: t,
    displayName: u(e, "data-user-displayname"),
    isAdmin: !!window._oc_isadmin
  }, n);
}
exports.getCurrentUser = c;
exports.getRequestToken = a;
exports.onRequestTokenUpdate = d;
